import { ApiAuthorization, ApiDataModel, ApiModule } from '@/api/apiConstants'

const groupPrefix = createApiRoute(ApiModule.AUTH, ApiAuthorization.EMPLOYEE, ApiDataModel.FACILITIES)

export const apiEmployeeFacility = {
	fetchAvailableFacilities: async (): Promise<IEmployeeFacilityModel[]> => {
		const { data } = await apiCommon<IEmployeeFacility[]>(`${groupPrefix}`, { method: 'GET' })

		return data.map(f => EmployeeFacility(f))
	},
}
